import { render, staticRenderFns } from "./MainComponent.vue?vue&type=template&id=19aed859&scoped=true&"
import script from "./MainComponent.vue?vue&type=script&lang=js&"
export * from "./MainComponent.vue?vue&type=script&lang=js&"
import style0 from "./MainComponent.vue?vue&type=style&index=0&id=19aed859&prod&scoped=true&lang=css&"
import style1 from "./MainComponent.vue?vue&type=style&index=1&id=19aed859&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19aed859",
  null
  
)

export default component.exports